import { ArrowBack } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useWall } from '../../App';
import { Flex, Label } from '../../style';
import { sizes } from '../../variables';
import { Container } from './style';

const NoContent = () => {
  const { setWalletAddress, setCustomAddress } = useWall();
  const navigate = useNavigate();
  return <Container>
    <img src="/assets/logo.svg" width="10%" />
    <Label fontFamily="Julius Sans One" fontSize={sizes.xl2} textAlign="center" className='add-padding'>
      <span className="highlight">Sorry, </span>we couldn't load any nfts from this address
    </Label>
    <Flex justifyContent="center" gap={sizes.lg} alignItems="center" className="add-padding">
      <Button color="primary" size="large" onClick={() => navigate('/about')} aria-label="Navigate to the about page">
        <ArrowBack sx={{ marginRight: sizes.xs2 }} />
        Learn more about wallverse
      </Button>
      <Button variant="outlined" aria-label="Navigate to empty wall page" size="large" onClick={() => {
        setWalletAddress('');
        setCustomAddress('');
        navigate('/wall/empty')
      }}>
        Try with a different address
      </Button>
    </Flex>
  </Container>
}

export default NoContent;